(function (angular) {
  'use strict';
  angular
    .module('bossApp')
    .constant('localeEN',
      {
        "boss-header-boss-banking":"Banking One Stop Solution",
        "boss-header-BOSS":"",
        "boss-header-by":"by",
        "boss-header-BBVA":"BBVA",
        "boss-header-Hola":"Hola",
        "boss-header-informacion-control":"Información y control de tus cuentas y tesorería desde un único lugar.",

        "boss-login-integra-informacion":"Integra la información de todas tus cuentas bancarias y controla tu tesorería desde un único lugar.",
        "boss-login-acceso":"Acceso",
        "boss-login-ingresa-credenciales":"Ingresa con tus credenciales de BBVA Netcash",
        "boss-login-referencia":"Referencia / Código empresa",
        "boss-login-usuario":"Usuario",
        "boss-login-password":"Contraseña",
        "boss-login-ingresar":"Continuar",

        "boss-olvido-olvidado-contrasena":"No recuerdo mi contraseña",

        "boss-bossError-mensaje-error":"Mensaje de error",
        "boss-bossError-saber-mas":"Saber más",
        "boss-bossError-code-default":"Se ha producido un error al intentar acceder al sistema. Por favor, inténtelo más tarde",
        "boss-bossError-code-EAI0000":"Revisa tus claves y/o verifica con tu gestor que tienes activado BBVA One View",
        "boss-bossError-code-EAI0008":"El usuario está bloqueado",
        "boss-bossError-code-ERROR500":"Servicio temporalmente no disponible. Por favor, inténtelo más tarde",
        "boss-bossError-code-NOPILOTO":"Por favor, contacte con su gestor para contratar BBVA BOSS",
        "boss-bossError-code-USERDUPLICATED":"Ya hay un usuario con acceso a OneView",
        "boss-bossError-code-no-administrador-solidario": "El usuario no es administrador solidario.",
        "boss-login-XXX":"XXX"
      }
    )

})(angular);
